import { SVGProps } from 'react';

const IcSearch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.77403 2.7085C5.97707 2.7085 2.89903 5.78654 2.89903 9.5835C2.89903 13.3805 5.97707 16.4585 9.77403 16.4585C13.571 16.4585 16.649 13.3805 16.649 9.5835C16.649 5.78654 13.571 2.7085 9.77403 2.7085ZM1.64903 9.5835C1.64903 5.09618 5.28672 1.4585 9.77403 1.4585C14.2613 1.4585 17.899 5.09618 17.899 9.5835C17.899 14.0708 14.2613 17.7085 9.77403 17.7085C5.28672 17.7085 1.64903 14.0708 1.64903 9.5835Z'
        fill={props.fill || '#1D2129'}
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.3468 14.5464C14.5905 14.302 14.9863 14.3015 15.2307 14.5453L18.1673 17.4743C18.4117 17.7181 18.4123 18.1138 18.1685 18.3582C17.9247 18.6026 17.529 18.6031 17.2846 18.3594L14.3479 15.4303C14.1035 15.1865 14.103 14.7908 14.3468 14.5464Z'
        fill={props.fill || '#1D2129'}
      />
    </svg>
  );
};

export default IcSearch;
